module.exports = __webpack_public_path__ + "img/header_logo.2f83d9f1.png";